<template>
  <el-dialog :visible.sync="dialogVisible" width="1400px" :show-close="false">
    <img
      class="close-img"
      alt="close-icon.png"
      @click="dialogVisible = false"
      src="@/assets/img/images/icon/close-icon.png"
    />
    <p class="dialog-title">
      {{ $t("exchangeRecord.title", { coin: coin }) }}
    </p>
    <div class="box" v-loading="loading">
      <NoData v-if="tableData.length <= 0 && !loading" />
      <el-table
        v-else
        :data="tableData"
        style="width: 100%"
        header-cell-class-name="table-head"
        cell-class-name="table-cell"
        @row-click="handleRowClick"
      >
        <el-table-column
          align="center"
          width="200"
          :label="$t('exchangeRecord.order_no')"
        >
          <template slot-scope="scope">
            <span style="color: #333333; font-weight: 600">{{ scope.row.orderNo }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('exchangeRecord.transfer_amount')"
        >
          <template slot-scope="scope">
            <span style="color: #a0aac1">{{ formatNumber(scope.row.transferAmount) }} {{ scope.row.exchangeBase }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('exchangeRecord.ht_amount')"
        >
          <template slot-scope="scope">
            <span style="color: #a0aac1">{{ formatNumber(scope.row.htAmount) }} {{ scope.row.exchangeCoin }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :label="$t('exchangeRecord.actual_transfer')"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.rechargeAmount != null" style="color: var(--primary-color); font-weight: 600">{{ formatNumber(scope.row.rechargeAmount) }} {{ scope.row.exchangeCoin }}</span>
            <span v-else style="color: #a0aac1">- -</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="200"
          :label="$t('exchangeRecord.rate')"
        >
          <template slot-scope="scope">
            <span style="color: #a0aac1">1 {{ scope.row.exchangeBase }} = {{ scope.row.rate }} {{ scope.row.exchangeCoin }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="220"
          :label="$t('exchangeRecord.recharge_time')"
        >
          <template slot-scope="scope">
            <span style="color: #a0aac1">{{ scope.row.rechargeTime }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          width="120"
          :label="$t('exchangeRecord.status')"
        >
          <template slot-scope="scope">
            <span :style="{ color: getStatusColor(scope.row.status) }">{{ getStatusText(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          align="center"
          :label="$t('exchangeRecord.reject_reason')"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.status === 'rejected' && scope.row.rejectReason" style="color: #ff4d4f">{{ scope.row.rejectReason }}</span>
            <span v-else style="color: #a0aac1">- -</span>
          </template>
        </el-table-column> -->
      </el-table>
      <el-pagination
        v-if="total > 0"
        class="pagination-box"
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="handlePageChange"
        :current-page.sync="filter.page"
        :page-size="filter.rows"
      />
    </div>
    <ExchangeDetailDialog ref="exchangeDetailDialogRef" />
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import NoData from "@/components/NoData";
import ExchangeDetailDialog from "./ExchangeDetailDialog";
export default {
  components: {
    NoData,
    ExchangeDetailDialog,
  },
  computed: {
    ...mapState(["errorCode"]),
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      coin: "",
      tableData: [],
      total: 0,
      filter: {
        page: 1,
        rows: 10,
      },
    };
  },
  methods: {
    initDialog(coin) {
      this.coin = coin || "";
      this.dialogVisible = true;
      this.filter.page = 1;
      this.loadRecordList();
    },
    handlePageChange(page) {
      this.filter.page = page;
      this.loadRecordList();
    },
    handleRowClick(row) {
      this.$refs.exchangeDetailDialogRef.initDialog(row.id, row.exchangeCoin || this.coin);
    },
    loadRecordList() {
      this.loading = true;
      const params = {
        page: this.filter.page,
        rows: this.filter.rows,
        queryType: "deposit",
        flowType: "hkd_exchange",
      };
      if (this.coin) {
        params.coinType = this.coin;
      }
      this.$axios
        .post("/userAssets/tranRecord", params)
        .then((res) => {
          if (
            res.data.code === this.errorCode.ok &&
            res.data.data &&
            res.data.data.deposit
          ) {
            const rows = res.data.data.deposit.rows || [];
            this.tableData = rows.map((item) => this.mapRecord(item));
            this.total = res.data.data.deposit.total || 0;
          }
        })
        .catch(() => {
          this.tableData = [];
          this.total = 0;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    parseMemo(memo) {
      if (!memo) return {};
      try {
        return typeof memo === "string" ? JSON.parse(memo) : memo;
      } catch (e) {
        return {};
      }
    },
    mapRecord(item) {
      const memoObj = this.parseMemo(item.memo);
      const exchangeInfo = memoObj.exchangeInfo || {};
      return {
        id: item.id,
        orderNo: item.txHash || "",
        status: this.mapStatus(item.status, item.statusStr),
        transferAmount: item.value,
        rechargeAmount: memoObj.rechargeAmount,
        htAmount: exchangeInfo.exchangeAmount,
        rate: exchangeInfo.exchangeRate,
        exchangeBase: exchangeInfo.exchangeBase || "",
        exchangeCoin: exchangeInfo.exchangeCoin || "",
        rechargeTime: item.createTime
          ? this.dateFormatter(
              new Date(item.createTime),
              "yyyy-MM-dd hh:mm:ss",
            )
          : "",
        rejectReason: item.remark || item.rejectReason || "",
      };
    },
    mapStatus(status, statusStr) {
      const str = statusStr || "";
      if (str.indexOf("拒") > -1 || str.toLowerCase().indexOf("reject") > -1) {
        return "rejected";
      }
      if (
        str.indexOf("完成") > -1 ||
        str.indexOf("成功") > -1 ||
        str.toLowerCase().indexOf("complet") > -1 ||
        str.toLowerCase().indexOf("success") > -1
      ) {
        return "completed";
      }
      if (str.indexOf("审核") > -1 || str.toLowerCase().indexOf("pend") > -1) {
        return "pending";
      }
      switch (Number(status)) {
        case 1:
          return "completed";
        case 0:
          return "rejected";
        case 3:
          return "pending";
        default:
          return "pending";
      }
    },
    getStatusColor(status) {
      const colorMap = {
        completed: "#52c41a",
        pending: "var(--primary-color)",
        rejected: "#ff4d4f",
      };
      return colorMap[status] || "var(--primary-color)";
    },
    getStatusText(status) {
      const textMap = {
        completed: this.$t("exchangeRecord.status_completed"),
        pending: this.$t("exchangeRecord.status_pending"),
        rejected: this.$t("exchangeRecord.status_rejected"),
      };
      return textMap[status] || status;
    },
    formatNumber(num) {
      if (!num && num !== 0) return "0.00";
      return Number(num).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-dialog {
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  .el-dialog__body {
    padding-top: 0px;
    position: relative;
  }
}

.close-img {
  top: -10px;
  right: 20px;
  width: 12px;
  height: 12px;
  cursor: pointer;
  position: absolute;
  z-index: 10;
}

.dialog-title {
  font-family: PingFang SC, PingFang SC;
  font-weight: 800;
  font-size: 24px;
  color: #333333;
  margin-bottom: 20px;
}

.box {
  display: flex;
  margin-top: 20px;
  flex-direction: column;
  /deep/.table-head {
    background: rgba(234, 235, 237, 0.5);
  }
  /deep/.table-head:first-child {
    border-radius: 6px 0px 0px 6px;
  }
  /deep/.table-head:last-child {
    border-radius: 0px 6px 6px 0px;
  }
  /deep/.table-cell {
    border: none;
  }
  /deep/ .el-table__body tr.current-row > td {
    background-color: rgba(225, 234, 255, 0.6) !important;
  }
  /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(225, 234, 255, 0.6) !important;
  }
}

.pagination-box {
  text-align: center;
  margin-top: 60px;
  margin-bottom: 120px;
  /deep/ .btn-prev,
  /deep/ .btn-next,
  /deep/ .number {
    width: 44px;
    height: 44px;
    line-height: 44px;
    background: #ffffff;
    box-shadow: 0px 3px 10px 1px rgba(180, 180, 180, 0.06);
    border-radius: 6px 6px 6px 6px;
  }
  /deep/ .active {
    background-color: var(--primary-color) !important;
  }
}
</style>
